import { render, staticRenderFns } from "./grossing-touch-sidepanel-wrapper.vue?vue&type=template&id=aa062772&scoped=true&"
import script from "./grossing-touch-sidepanel-wrapper.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sidepanel-wrapper.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sidepanel-wrapper.scss?vue&type=style&index=0&id=aa062772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa062772",
  null
  
)

export default component.exports